var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor3New(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3406,
    height: 2369,
    viewBox: "0 0 3406 2369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "3_52",
    d: "M1150.5 1247L1419.5 1072.5L1553 1277.5L1504 1310.5L1508.5 1316.5L1258.5 1478.5L1204 1393.5L1225.33 1379.63L1174 1299L1181 1294L1150.5 1247Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "3_36",
    d: "M3154 1024.12V1255.34H2765.35L2765.97 1024.12H3154Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "3_35",
    d: "M3153.5 783.186V1024.19H2765.81L2764.2 783.186H3153.5Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "3_34",
    d: "M2763.57 782V905.564H2685.53V1029.13H2629.28V1128.49H2409.04V1142.5H2351.5L2350 782H2763.57Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "3_37",
    d: "M3154 1255.35V1488.17H2765.34V1255.35H3154Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "3_33",
    d: "M2624.19 1566.19V2021.19H2368.19V1566.19H2624.19Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "3_40",
    d: "M2368.19 1699.19V2021.19H2141.19V1699.19H2368.19Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "3_41",
    d: "M2141.19 1699.19V2021.19H1912.19V1699.19H2141.19Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "3_31",
    d: "M2141.19 1316.19V1638.19H1912.19V1316.19H2141.19Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "3_30",
    d: "M1912.19 1316.19V1638.19H1660.19V1560.19H1634.19V1316.19H1912.19Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "3_42",
    d: "M1912.19 1696V2021.18L1682 2019.51V1964.5H1675.5V1696H1912.19Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "3_45",
    d: "M1303.46 1684.66L1302.62 1685.2L1303.16 1686.04L1323.63 1718.21L1303.45 1731.67L1302.68 1732.18L1303.13 1732.98L1305.19 1736.69L1292.93 1745.18L1292.13 1745.73L1292.66 1746.55L1299.61 1757.2L1098.39 1885.68L965.063 1680.37L1207.71 1523.87L1311.11 1679.71L1303.46 1684.66Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "3_46",
    d: "M1007.81 1641.59L1004.34 1635.96L1003.79 1635.07L1002.93 1635.66L955.275 1668.08L826.888 1470.3L892.515 1429.84L893.383 1429.3L892.831 1428.44L888.867 1422.28L1087.19 1291.4L1100.65 1313.03L1101.18 1313.88L1102.03 1313.35L1113.2 1306.37L1156.12 1371.72L1144.95 1379.17L1144.14 1379.71L1144.65 1380.53L1162.64 1409.52L1163.17 1410.37L1164.02 1409.84L1183.22 1397.83L1187.68 1404.07L1188.26 1404.88L1189.07 1404.3L1203.72 1393.9L1258.61 1478.19L1007.81 1641.59Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "3_47",
    d: "M1015.47 1180.15L1014.58 1180.71L1015.18 1181.57L1036.18 1211.57L1036.76 1212.41L1037.59 1211.81L1045.74 1205.92L1074.66 1250.27L1064.39 1258.21L1063.62 1258.8L1064.19 1259.59L1087.08 1291.24L888.952 1420.67L888.096 1421.23L888.676 1422.07L893.58 1429.2L827.304 1470.14L701.038 1276.9L978.718 1103.85L1026.58 1173.21L1015.47 1180.15Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "3_51",
    d: "M1299.12 898.703L1036.29 1069.62L1012.33 1033.45L1011.8 1032.64L1010.97 1033.15L1003.8 1037.63L899.535 876.752L1167.71 695.399L1299.12 898.703Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "3_50",
    d: "M898.982 875.287L772.582 678.499L983.028 547.848L983.905 547.304L983.332 546.444L979.89 541.281L1041.21 500.887L1168.12 695.218L898.982 875.287Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "3_48",
    d: "M979.118 1103.68L700.497 1275.82L520.342 998.405L788.438 822.125L868.157 946.539L868.698 947.383L869.541 946.841L875.704 942.878L906.128 989.723L894.438 997.674L893.644 998.214L894.151 999.029L910.651 1025.53L911.173 1026.37L912.018 1025.85L925.178 1017.86L979.118 1103.68Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "3_49",
    d: "M1041.12 500.216L980.445 540.669L979.614 541.224L980.168 542.056L983.596 547.197L773.162 678.336L772.297 678.876L772.853 679.73L791.792 708.867L733.673 744.328L732.791 744.867L733.358 745.731L784.312 823.398L520.48 998.291L237.886 565.793L833.206 179.882L1041.12 500.216Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "3_43",
    d: "M1675.5 1965H1681V2019H1447V1966H1442V1696.5L1675.5 1696V1965Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "3_44",
    d: "M1441 1696.5V1965.5H1218.54L1146.89 1857.29L1299.55 1757.84L1300.41 1757.28L1299.82 1756.43L1292.39 1745.75L1304.57 1737.32L1305.31 1736.81L1304.87 1736.01L1302.83 1732.33L1324.8 1718H1378.5V1696.5H1441Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "3_32",
    d: "M2375.25 1316.19V1372.38H2624.19V1565.29H2368.19V1638.19H2141.19V1316.19H2375.25Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "3_38",
    d: "M3154 1488.19V1720.19H2862.19V1620.19H2765.19V1488.19H3154Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "3_39",
    d: "M2861.19 1621.69V1720.19H3147.19V1970.19H2868.19V2021.19H2624.69V1621.69H2861.19Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor3New);
export default __webpack_public_path__ + "static/media/select_floor_3_new.87cc8155679eaa0f84e867aa89eea6e1.svg";
export { ForwardRef as ReactComponent };